import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/Authcontext';
import { getAllUsers, deleteUser, createUser } from '../services/user';
import './AdminPage.css';

const AdminPage = () => {
  const { auth } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({
    username: '',
    password: '',
    role: 'user',
    iframe: ''
  });

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getAllUsers(auth);
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, [auth]);

  const handleDelete = async (id) => {
    try {
      await deleteUser(id, auth);
      setUsers(users.filter(user => user.id !== id));
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = await createUser(newUser, auth);
      setUsers([...users, user]);
      setNewUser({ username: '', password: '', role: 'user', iframe: '' });
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  return (
    <div className="admin-container">
      <h2>Admin Page</h2>
      <form onSubmit={handleSubmit} className="create-user-form">
        <div className="form-group">
          <label>Username:</label>
          <input type="text" name="username" value={newUser.username} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input type="password" name="password" value={newUser.password} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Role:</label>
          <select name="role" value={newUser.role} onChange={handleChange}>
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div className="form-group">
          <label>Iframe URL:</label>
          <input type="text" name="iframe" value={newUser.iframe} onChange={handleChange} />
        </div>
        <button type="submit" className="create-button">Create User</button>
      </form>
      <div className="users-list">
        <h3>Existing Users</h3>
        <ul>
          {users.map(user => (
            <li key={user.id}>
              {user.username} - {user.role}
              <button onClick={() => handleDelete(user.id)} className="delete-button">Delete</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminPage;
